// Horse profile history card. Mirrors data-component="horse-profile-history".
// Read-only history of profile edits with a status footer line.
//
// TODO(runtime): hydrate from services/horse-timeline event stream
// filtered to profile_update + rep_authored notes (proposed - TODO
// runtime; service exists).
import type { ReactNode } from 'react';
import type { HorseProfile } from '../mockData.js';
import { HORSE_FIELD_LABELS, type HorseChange, type HorseEditorValues } from '../reviewState.js';

export interface HorseProfileHistoryProps {
  horse: HorseProfile;
  historyStatus: string;
  events?: HorseChange[];
}

export function HorseProfileHistory({ horse, historyStatus, events = [] }: HorseProfileHistoryProps): ReactNode {
  const items = horse.profileHistory;
  return (
    <section className="card" data-component="horse-profile-history">
      <div className="section-heading">
        <h3>Horse profile history</h3>
        <span>Changes stay with {horse.name}</span>
      </div>
      {events.slice().reverse().map(event => <article className="horse-history" key={event.id}>
        <i /><div>
          <strong>{event.kind === 'added' ? 'Horse added' : event.kind === 'routine' ? 'Daily routine updated' : event.kind === 'goals' ? 'Customer goals updated' : event.kind === 'story' ? 'Horse story updated' : 'Horse profile updated'}</strong>
          <small>{event.actor} · {new Date(event.recordedAt).toLocaleString('en-US')}</small>
          {(Object.keys(event.after) as Array<keyof HorseEditorValues>).map(key => <p key={key}>
            <b>{HORSE_FIELD_LABELS[key]}</b>: {event.before[key] || 'Not recorded'} → {event.after[key] || 'Not recorded'}
          </p>)}
          {event.effectiveDate && <p>Effective {event.effectiveDate}</p>}
          {event.note && <p>{event.note}</p>}
        </div>
      </article>)}
      {items.map((entry, index) => (
        <div className="horse-history" key={entry.title + index}>
          <i />
          <div>
            <strong>{entry.title}</strong>
            <p>{entry.detail}</p>
            <small>{entry.note}</small>
          </div>
        </div>
      ))}
      {historyStatus && <p className="horse-small">{historyStatus}</p>}
    </section>
  );
}
